import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles<{ selected: boolean }>()((theme, { selected }) => ({
  root: {
    minWidth: 0,
    color: selected ? theme.palette.primary.main : 'inherit',
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    userSelect: 'none',
  },
  icon: {
    width: 18,
    height: 18,
    flexShrink: 0,
  },
  helperText: {
    display: 'block',
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(0.5),
    userSelect: 'none',
  },
}));

type ExclusionOptionContentProps = {
  label: string;
  helperText: string;
  Icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  selected?: boolean;
};

export default function ExclusionOptionContent({
  label,
  helperText,
  Icon,
  selected = false,
}: ExclusionOptionContentProps): React.JSX.Element {
  const { classes } = useStyles({ selected });

  return (
    <Box className={classes.root}>
      <Box className={classes.label}>
        <Typography variant='bodyRegular'>{label}</Typography>
        <Icon className={classes.icon} />
      </Box>
      <Typography variant='captionRegular' className={classes.helperText}>
        {helperText}
      </Typography>
    </Box>
  );
}
